export default "__VITE_ASSET__ujkHPy1g__"